var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 0.28617948,0.93014275 a 0.92846116,0.92846116 0 0 1 0.2720019,-0.6582697 0.92846116,0.92846116 0 0 1 1.31290922,0 L 7.4418575,5.84264 a 0.928554,0.928554 0 0 1 0,1.3147195 L 1.8710906,12.728127 a 0.92846116,0.92846116 0 0 1 -1.31290922,0 0.92846116,0.92846116 0 0 1 0,-1.31472 L 5.4724985,6.5009097 0.55818138,1.5865927 A 0.92846116,0.92846116 0 0 1 0.28617948,0.93014275 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.9c2cd6f229935f802687206a37c54cd4.svg";
export { ForwardRef as ReactComponent };